import React from 'react';

import { LinkButton } from '@atlaskit/button/new';

const LinkButtonWarningExample = (): React.JSX.Element => {
	return (
		<LinkButton appearance="warning" href="https://atlassian.com/">
			Warning link button
		</LinkButton>
	);
};

export default LinkButtonWarningExample;
